import React from 'react'
import PropTypes from 'prop-types'
import {Label, Input} from 'reactstrap'

const propTypes = {
  label: PropTypes.string.isRequired,
  onChangeFunc: PropTypes.func.isRequired,
  checked: PropTypes.bool
}

const defaultProps = {
  checked: false
}

const SwitchRadioBtn = ({label, onChangeFunc, checked}) => {
  return (
    <div className="float-left"><label>{label}</label> &nbsp;
      <Label id="show-certificates-switch" className="switch switch-sm switch-text switch-info mb-0">
        <Input type="checkbox" className="switch-input" checked={checked} onChange={onChangeFunc}/>
        <span className="switch-label" data-on="On" data-off="Off"/>
        <span className="switch-handle"/>
      </Label>
      &nbsp;
    </div>
  )
}

SwitchRadioBtn.propTypes = propTypes
SwitchRadioBtn.defaultProps = defaultProps

export default SwitchRadioBtn



// WEBPACK FOOTER //
// ./src/components/Support/SwitchRadioBtn.js